import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'baseImage'
})
export class BaseImagePipe implements PipeTransform {

  transform(value: string | unknown[], ...args: unknown[]): string | null {
    if (!value) {
      return null;
    }
  
    let image: string | null = null;
  
    if (typeof value === 'string') {
      try {
        const images = JSON.parse(value);
        if (Array.isArray(images) && images.length > 0) {
          image = images[0];
        }
      } catch {
        image = value;
      }
    } else if (Array.isArray(value) && value.length > 0) {
      image = value[0] as string;
    }
  
    return image;
  }
  

}
